import paraService from "../../services/parameterService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new paraService();

export const getParaList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_PARA,
      payload: { ...initialState, loading: true },
    });
    service
      .getParaList(data)
      .then((res) => {
        dispatch({
          type: types.GET_PARA,
          payload: { data: res.data.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_PARA,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const getParaMeta = () => {
  return (dispatch) => {
    dispatch({
      type: types.META_LIST,
      payload: { ...initialState, loading: true },
    });
    service
      .getMetaList()
      .then((res) => {
        dispatch({
          type: types.META_LIST,
          payload: { data: res.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.META_LIST,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching limit dropdown",
            loading: false,
          },
        });
      });
  };
};

export const AddParameter = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.ADD_PARA,
      payload: { ...initialState, loading: true },
    });
    return service
      .addParameter(data)
      .then((res) => {
        dispatch({
          type: types.ADD_PARA,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.ADD_PARA,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });

  };
};

export const DeletePara = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.DELETE_PARA,
      payload: { ...initialState, loading: true },
    });
    return service
      .deletePara(data)
      .then((res) => {
        dispatch({
          type: types.DELETE_PARA,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })

      .catch((error) => {
        const errorMessage =
          error?.response?.data?.error || error?.message || "Error fetching data";
        dispatch({
          type: types.DELETE_PARA,
          payload: {
            ...initialState,
            message: errorMessage,
            error: errorMessage,
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const UpdatePara = (payload) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_PARA,
      payload: { ...initialState, loading: true },
    });
    return service
      .updatePara(payload)
      .then((res) => {
        dispatch({
          type: types.UPDATE_PARA,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res
      })
      .catch((error) => {
        dispatch({
          type: types.UPDATE_PARA,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error;
      });
  };
};


export const AddPhase = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.ADD_PHASE,
      payload: { ...initialState, loading: true },
    });
    return service
      .addPhase(data, obj)
      .then((res) => {
        dispatch({
          type: types.ADD_PHASE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.ADD_PHASE,
          payload: {
            ...initialState,
            message: error.message || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const UpdatePhase = (payload) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_PHASE,
      payload: { ...initialState, loading: true },
    });
    return service
      .updatePhase(payload)
      .then((res) => {
        dispatch({
          type: types.UPDATE_PHASE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res
      })
      .catch((error) => {
        dispatch({
          type: types.UPDATE_PHASE,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error;
      });
  };
};

export const getPhaseList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_PHASE,
      payload: { ...initialState, loading: true },
    });
    service
      .getPhaseList(data)
      .then((res) => {
        dispatch({
          type: types.GET_PHASE,
          payload: { data: res.data.data, loading: false, status: 200 },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_PHASE,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const deletePhase = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.DELETE_PHASE,
      payload: { ...initialState, loading: true },
    });
    return service
      .deletePhase(data, obj)
      .then((res) => {
        dispatch({
          type: types.DELETE_PHASE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.DELETE_PHASE,
          payload: {
            ...initialState,
            message: error.message || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

//table
export const AddTableLevel = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.ADD_TABLE,
      payload: { ...initialState, loading: true },
    });
    return service
      .addTable(data, obj)
      .then((res) => {
        dispatch({
          type: types.ADD_TABLE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.ADD_TABLE,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const UpdateTableLevel = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_TABLE,
      payload: { ...initialState, loading: true },
    });
    return service
      .updateTable(data, obj)
      .then((res) => {
        dispatch({
          type: types.UPDATE_TABLE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.UPDATE_TABLE,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};


export const deleteTableLevel = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.DELETE_PHASE,
      payload: { ...initialState, loading: true },
    });
    return service
      .deleteTable(data, obj)
      .then((res) => {
        dispatch({
          type: types.DELETE_PHASE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.DELETE_PHASE,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const getTableList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_TABLE,
      payload: { ...initialState, loading: true },
    });
    service
      .getTableList(data)
      .then((res) => {
        dispatch({
          type: types.GET_TABLE,
          payload: { data: res.data.data, loading: false, status: 200 },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_TABLE,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};


export const reOrderColumn = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.REORDER_COLUNM,
      payload: { ...initialState, loading: true },
    });
    return service
      .reOrderColumn(data)
      .then((res) => {
        dispatch({
          type: types.REORDER_COLUNM,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.REORDER_COLUNM,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const reOrderSheet = (data, obj) => {
  return (dispatch) => {
    dispatch({
      type: types.REORDER_SHEET,
      payload: { ...initialState, loading: true },
    });
    return service
      .reOrderSheet(data, obj)
      .then((res) => {
        dispatch({
          type: types.REORDER_SHEET,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.REORDER_SHEET,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const restoreParameter = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.RESTORE_PARAMETER,
      payload: { ...initialState, loading: true },
    });
    return service
      .restoreParameter(data)
      .then((res) => {
        dispatch({
          type: types.RESTORE_PARAMETER,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.RESTORE_PARAMETER,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const templateView = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.TEMPLATE_VIEW,
      payload: { ...initialState, loading: true },
    });
    return service
      .templateView(data)
      .then((res) => {
        dispatch({
          type: types.TEMPLATE_VIEW,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.TEMPLATE_VIEW,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};

export const approveParameter = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.APPROVE_PARAMETER,
      payload: { ...initialState, loading: true },
    });
    return service
      .approvePara(data)
      .then((res) => {
        dispatch({
          type: types.APPROVE_PARAMETER,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: types.APPROVE_PARAMETER,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};
